// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__31hDR","left":"InfoRow_left__2Vaw7"};